import React, { useRef, useState, useEffect } from "react";
import axios from "axios";
import { Link, useNavigate, useParams } from "react-router-dom";
import Slider from "react-slick";
import { Header } from "../Header";
import { Footer } from "../Footer";
import { ReactDialogBox } from "react-js-dialog-box";
import generatePDF from "./PDFscore";
import "react-js-dialog-box/dist/index.css";
import "../assets/ohs/admin.css";
import "../assets/ohs/responsibility.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
export const Healthresponsibility = () => {
  const inputRef = useRef(null);
  const forth = useRef();
  const fifth = useRef();
  const inputRef_q1 = useRef(null);
  const inputRef_q2 = useRef(null);
  const [PdfcardImg, setPdfcardImg] = useState("");
  const [scoreCard, setscoreCard] = useState("");
  const { id } = useParams();
  const changeFavicon = (url) => {
    const favicon = document.querySelector('link[rel="icon"]');
    if (favicon) {
      favicon.href = url;
    }
  };
  const [name_9, setname_9] = useState(false);
  const [closeBox, setcloseBox] = useState(true);
  const [worngansQuiz_1_1, setworngansQuiz_1_1] = useState(false);
  const [rightansQuiz_1_1, setrightansQuiz_1_1] = useState(false);
  const [lesson1, setlesson1] = useState(true);
  const [lesson2, setlesson2] = useState(false);
  const [lesson3, setlesson3] = useState(false);
  const [lesson4, setlesson4] = useState(false);
  const [lesson5, setlesson5] = useState(false);
  const [leftmenu_bar, setleftmenu_bar] = useState(0);
  const [barwidth, setbarwidth] = useState(0);
  //Lesson 1 Start
  const [strokeDashArray_less1, setStrokeDashArray_less1] = useState("");
  const [istruefalse_1, setistruefalse_1] = useState(false);
  const [finalperc, setfinalperc] = useState("220");
  const [stroke_1, setstroke_1] = useState("#F50057");
  const [isresult, setisresult] = useState("");
  const [quiz1_result_section, setquiz1_result_section] = useState(false);
  const [subbtn_1, setsubbtn_1] = useState(false);
  const [issetQuizAns_1_btn, setQuizAns_1_btn] = useState("");
  const [issetQuizAns_1, setQuizAns_1] = useState("");
  const [checkQ_1, setcheckQ_1] = useState("");
  const [userChooseAns_1, setuserChooseAns_1] = useState("");
  const [firstsub, setfirstsub] = useState(false);
  const [isfirstquiz, setfirstquiz] = useState("");
  const [worngansQuiz_1, setworngansQuiz_1] = useState(false);
  const [rightansQuiz_1, setrightansQuiz_1] = useState(false);
  const [isOpacity, setisOpacity] = useState(false);
  const [isOpacity_11, setisOpacity_11] = useState(false);
  const [startQuestion_1, setstartQuestion_1] = useState(true);
  const [fans, setfans] = useState(false);
  //Lesson 1 End

  //Lesson 2 Start
  const [strokeDashArray_less2, setStrokeDashArray_less2] = useState("");
  const [istruefalse_2, setistruefalse_2] = useState(false);
  //Lesson 2 End

  //Lesson 3 Start
  const [strokeDashArray_less3, setStrokeDashArray_less3] = useState("");
  const [istruefalse_3, setistruefalse_3] = useState(false);
  //Lesson 3 end

  //Lesson 4 Start
  const [strokeDashArray_less4, setStrokeDashArray_less4] = useState("");
  const [istruefalse_4, setistruefalse_4] = useState(false);
  //Lesson 4 end

  //Lesson 5 Start
  const [strokeDashArray_less5, setStrokeDashArray_less5] = useState("");
  const [istruefalse_5, setistruefalse_5] = useState(false);
  const [quizless_5_1, setquizless_5_1] = useState(false);
  const [quizless_5_2, setquizless_5_2] = useState(false);
  const [quizless_5_3, setquizless_5_3] = useState(false);
  const [quizless_5_4, setquizless_5_4] = useState(false);
  const [quizless_5_5, setquizless_5_5] = useState(false);
  const [less_5_finresult, setless_5_finresult] = useState(false);
  const [name_5, setname_5] = useState(false);
  const [isfirstquiz_5_1, setisfirstquiz_5_1] = useState(false);
  const [issetQuizAns_5_1_btn, setissetQuizAns_5_1_btn] = useState("");
  const [checkQ_5_1, setcheckQ_5_1] = useState("");
  const [checkbtn_quiz_1_5, setcheckbtn_quiz_1_5] = useState(false);
  const [q1_next, setq1_next] = useState(false);
  const [checkQ_5_2, setcheckQ_5_2] = useState("");
  const [isfirstquiz_5_2, setisfirstquiz_5_2] = useState(false);
  const [issetQuizAns_5_2_btn, setissetQuizAns_5_2_btn] = useState("");
  const [worngansQuiz_2, setworngansQuiz_2] = useState(false);
  const [rightansQuiz_2, setrightansQuiz_2] = useState(false);
  const [q2_next, setq2_next] = useState(false);
  const [checkbtn_quiz_2_5, setcheckbtn_quiz_2_5] = useState(false);
  const [isOpacity_1, setisOpacity_1] = useState(false);

  //Q3
  const [isOpacity_2, setisOpacity_2] = useState(false);
  const [checkQ_5_3, setcheckQ_5_3] = useState("");
  const [isfirstquiz_5_3, setisfirstquiz_5_3] = useState(false);
  const [issetQuizAns_5_3_btn, setissetQuizAns_5_3_btn] = useState(false);
  const [worngansQuiz_3, setworngansQuiz_3] = useState(false);
  const [rightansQuiz_3, setrightansQuiz_3] = useState(false);
  const [q3_next, setq3_next] = useState(false);
  const [checkbtn_quiz_3_5, setcheckbtn_quiz_3_5] = useState(false);
  //Q3
  //Q4
  const [isOpacity_3, setisOpacity_3] = useState(false);
  const [checkQ_5_4, setcheckQ_5_4] = useState(false);
  const [isfirstquiz_5_4, setisfirstquiz_5_4] = useState(false);
  const [issetQuizAns_5_4_btn, setissetQuizAns_5_4_btn] = useState(false);
  const [worngansQuiz_4, setworngansQuiz_4] = useState(false);
  const [rightansQuiz_4, setrightansQuiz_4] = useState(false);
  const [q4_next, setq4_next] = useState(false);
  const [checkbtn_quiz_4_5, setcheckbtn_quiz_4_5] = useState(false);
  //Q4
  //Q5
  const [isOpacity_4, setisOpacity_4] = useState(false);
  const [checkQ_5_5, setcheckQ_5_5] = useState(false);
  const [isfirstquiz_5_5, setisfirstquiz_5_5] = useState(false);
  const [issetQuizAns_5_5_btn, setissetQuizAns_5_5_btn] = useState(false);
  const [worngansQuiz_5, setworngansQuiz_5] = useState(false);
  const [rightansQuiz_5, setrightansQuiz_5] = useState(false);
  const [q5_next, setq5_next] = useState(false);
  const [checkbtn_quiz_5_5, setcheckbtn_quiz_5_5] = useState(false);
  const [score_5, setscore_5] = useState([]);
  const [score__per5, setscore__per5] = useState([]);
  const [corrScore, setcorrScore] = useState(false);
  const [sec_1, setsec_1] = useState(true);
  const [stokebar, setstokebar] = useState([]);
  //Q5
  //Lesson 5 end
  useEffect(() => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    if (userStr === null) {
      window.location.href = "/login";
    }
    changeFavicon(require("../assets/admin/images/f-icon.png"));

    document.title = "Start Course";

    let formdata = {
      code: id,
    };
    if (scoreCard != "") {
      pdfdataget();
      setscoreCard("");
    }
    console.log(score__per5);
  }, [id, scoreCard, PdfcardImg, score__per5]);
  function formatDate_notes() {
    const options = {
      day: "2-digit",
      month: "long", // Change to "long" for full month name
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      timeZone: "Australia/Perth",
    };

    const date = new Date();
    return date.toLocaleDateString("en-GB", options);
  }
  //Pdf
  function getimagedata(urll) {
    let formdata = {
      url: urll,
    };
    const imgBase64 =
      "data:image/png;base64,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";
    const mainpdf = (
      <html lang="en">
        <head>
          <meta charset="utf-8" />
          <link rel="icon" href="/" />
          <meta name="viewport" content="width=device-width, initial-scale=1" />
          <meta name="theme-color" content="#000000" />
          <meta
            name="description"
            content="Web site created using create-react-app"
          />
          <link
            href="https://fonts.googleapis.com/css2?family=Great+Vibes&family=Quattrocento:wght@400;700&display=swap"
            rel="stylesheet"
          />
        </head>
        <body>
          <table
            style={{
              width: "700px",
              margin: "0 auto",
              border: "10px solid rgb(0, 74, 173)",
            }}
          >
            <tbody style={{ width: "100%" }}>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h1
                    style={{
                      color: "rgb(0, 74, 173)",
                      fontSize: "35px",
                      textAlign: "center",
                      padding: "0px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Certificate of Training
                  </h1>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    This is to certify that
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#323232",
                        fontWeight: 400,
                        marginTop: "30px",
                        fontSize: "20px",
                        textAlign: "center",
                        padding: "5px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {name_9}
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      marginTop: "30px",
                      fontSize: "20px",
                      textAlign: "center",
                      padding: "5px 0px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    has successfully completed training in
                  </h2>
                </td>
              </tr>
              <tr>
                <td>
                  <div>
                    <h3
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "12px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      Health & Safety Responsibilities
                    </h3>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <div
                    style={{
                      padding: "10px 0px",
                      marginTop: "15px",
                    }}
                  >
                    <h5
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      undertaken on the date
                    </h5>
                    <h6
                      style={{
                        color: "#000",
                        fontWeight: 400,
                        fontSize: "20px",
                        textAlign: "center",
                        margin: "0px 0px",
                        fontFamily: '"Quattrocento", serif',
                      }}
                    >
                      {formatDate_notes()}
                    </h6>
                  </div>
                </td>
              </tr>
              <tr>
                <td>
                  <h2
                    style={{
                      color: "#323232",
                      fontWeight: 400,
                      fontSize: "20px",
                      textAlign: "center",
                      paddingTop: "40px",
                      fontFamily: '"Quattrocento", serif',
                    }}
                  >
                    Delivered by:
                  </h2>
                </td>
              </tr>
              <tr>
                <td style={{ textAlign: "center" }}>
                  <div
                    style={{
                      margin: "0 auto",
                      width: "250px",
                      paddingBottom: "10px",
                    }}
                  >
                    <img style={{ width: "50%" }} src={imgBase64} alt="logo" />
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </body>
      </html>
    );
    const filenamee = "Health & Safety Responsibilities";

    setTimeout(() => {
      generatePDF(mainpdf, filenamee);
    }, 500);
  }
  const pdfdataget = async () => {
    const cc = await getimagedata("logo1.png");
  };
  const downloadpdf = () => {
    const userStr = JSON.parse(localStorage.getItem("users"));

    let formdata = {
      user_id: userStr[0].id,
      id: id,
      name: name_9,
    };
    console.log(formdata);
    //setscoreCard(1);

    axios
      .post("https://jlmining.app/coursepdf", formdata, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      })
      .then((res) => { })
      .catch((err) => { });
    pdfdataget();
  };
  //Pdf
  const restart_lesson1 = () => {
    setStrokeDashArray_less1("");
    setistruefalse_1(false);
    setfinalperc("220");
    setstroke_1("#F50057");
    setisresult("");
    setquiz1_result_section(false);
    setsubbtn_1(false);
    setQuizAns_1_btn("");
    setQuizAns_1("");
    setcheckQ_1("");
    setuserChooseAns_1("");
    setfirstsub(false);
    setfirstquiz("");
    setworngansQuiz_1(false);
    setrightansQuiz_1(false);
    setisOpacity(false);
    setisOpacity_11(false);
    setstartQuestion_1(true);
    setfans(false);
    setworngansQuiz_1_1(false);
    setrightansQuiz_1_1(false);
  };
  const startQuiz_1 = (event) => {
    console.log(event);
    setQuizAns_1_btn(event);
    setQuizAns_1(event);
    setcheckQ_1(event);
    setuserChooseAns_1(event);
    setfirstsub(true);
    setistruefalse_1(true);
    setsubbtn_1(true);
  };
  const Quiz_check = (event) => {
    setQuizAns_1_btn("All");
    if (issetQuizAns_1_btn === "All") {
      setrightansQuiz_1_1(true);
      setfinalperc("345");
      setfans(true);
      setisresult("100%");
    } else {
      setfans(false);
      setworngansQuiz_1_1(true);
      setfinalperc("220");
      setstroke_1("");
      setisresult("0%");
    }
    setfirstquiz(true);
    setcheckQ_1("");
    setsubbtn_1(true);
    setisOpacity(true);
    setquiz1_result_section(true);
    setstartQuestion_1(false);
  };
  const lessonInstruction = (event) => {
    if (event === "1") {
      setlesson1(false);
      setlesson2(true);
    }
    if (event === "2") {
      setlesson1(true);
      setlesson2(false);
      // setistruefalse_1(false);
    }
    if (event === "3") {
      setlesson2(true);
      setlesson3(false);
      setistruefalse_2(false);
    }
  };
  const lessonInstructionbk = (event) => {
    if (event === "3") {
      setlesson3(true);
      setlesson4(false);
      setistruefalse_3(false);
    }
    if (event === "4") {
      setlesson4(true);
      setlesson5(false);
      setistruefalse_4(false);
      refreshassessment();
    }
  };
  const nextsection = (event) => {
    if (event === "2") {
      setlesson2(false);
      setlesson3(true);
      setistruefalse_2(true);
      setleftmenu_bar(30.66);
      setbarwidth(30);
    }
    if (event === "3") {
      setlesson3(false);
      setlesson4(true);
      setistruefalse_3(true);
      setleftmenu_bar(50.66);
      setbarwidth(50);
      setTimeout(() => {
        forth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
    if (event === "4") {
      setlesson4(false);
      setlesson5(true);
      setistruefalse_4(true);
      setleftmenu_bar(80.66);
      setbarwidth(80);
      setTimeout(() => {
        fifth.current.scrollIntoView({ behavior: "smooth" });
      }, 100);
    }
  };
  //Lesson Start 5
  const entername_5 = (event) => {
    const trimmedValue = event.target.value.trim();
    setname_5(trimmedValue);
  };
  const btn_entername = () => {
    if (name_5 !== false) {
      setquizless_5_1(true);
      setsec_1(false);
    }
  };

  const Quiz_check_5 = (event) => {
    if (event === "1") {
      setisOpacity_11(true);
      if (checkQ_5_1 === "False") {
        console.log("hjjj");
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_1(true);
        setworngansQuiz_1(false);
      } else {
        setworngansQuiz_1(true);
        setrightansQuiz_1(false);
      }
      setisfirstquiz_5_1(true);
      setQuizAns_1(true);
      setissetQuizAns_5_1_btn("False");
      setq1_next(true);
      setcheckQ_5_1("");
      setcheckbtn_quiz_1_5(false);
    }
    if (event === "2") {
      setisOpacity_1(true);
      if (checkQ_5_2 === "Provide_all") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_2(true);
        setworngansQuiz_2(false);
      } else {
        setworngansQuiz_2(true);
        setrightansQuiz_2(false);
      }
      setissetQuizAns_5_2_btn("Provide_all");
      setisfirstquiz_5_2(true);
      setq2_next(true);
      setcheckbtn_quiz_2_5(false);
      setcheckQ_5_2("");
    }
    if (event === "3") {
      setisOpacity_2(true);
      if (checkQ_5_3 === "All_of") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_3(true);
        setworngansQuiz_3(false);
      } else {
        setworngansQuiz_3(true);
        setrightansQuiz_3(false);
      }
      setissetQuizAns_5_3_btn("All_of");
      setisfirstquiz_5_3(true);
      setq3_next(true);
      setcheckbtn_quiz_3_5(false);
      setcheckQ_5_3("");
    }
    if (event === "4") {
      setisOpacity_3(true);
      if (checkQ_5_4 === "True") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_4(true);
        setworngansQuiz_4(false);
      } else {
        setworngansQuiz_4(true);
        setrightansQuiz_4(false);
      }
      setissetQuizAns_5_4_btn("True");
      setisfirstquiz_5_4(true);
      setq4_next(true);
      setcheckbtn_quiz_4_5(false);
      setcheckQ_5_4("");
    }
    if (event === "5") {
      setisOpacity_4(true);
      if (checkQ_5_5 === "Workers_must") {
        setscore_5((prevArray) => [...prevArray, 8]);
        setscore__per5((prevArray) => [...prevArray, 20]);
        setrightansQuiz_5(true);
        setworngansQuiz_5(false);
      } else {
        setworngansQuiz_5(true);
        setrightansQuiz_5(false);
      }
      setissetQuizAns_5_5_btn("Workers_must");
      setisfirstquiz_5_5(true);
      setq5_next(true);
      setcheckbtn_quiz_5_5(false);
      setcheckQ_5_5("");

      setleftmenu_bar(100);
      setbarwidth(100);
    }
  };
  const Quiz_next = (event) => {
    if (event === "1") {
      setquizless_5_1(false);
      setquizless_5_2(true);
    }
    if (event === "2") {
      setquizless_5_2(false);
      setquizless_5_3(true);
    }
    if (event === "3") {
      setquizless_5_3(false);
      setquizless_5_4(true);
    }
    if (event === "4") {
      setquizless_5_4(false);
      setquizless_5_5(true);
    }
    if (event === "5") {
      setistruefalse_5(true);
      setless_5_finresult(true);
      setquizless_5_5(false);
      const sum = score_5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      const sum_per = score__per5.reduce(
        (accumulator, currentValue) => accumulator + currentValue,
        0
      );
      console.log(score__per5);
      setscore_5(sum);
      setscore__per5(sum_per);
      if (sum_per >= 80) {
        setcorrScore(true);
      }
    }
  };
  const startQuiz_5_1 = (event) => {
    setcheckQ_5_1(event);
    //setissetQuizAns_5_1_btn(event);
    setcheckbtn_quiz_1_5(true);
    // setstokebar((prevArray) => [...prevArray, 14.3]);
    setStrokeDashArray_less5(200.36);
  };
  const startQuiz_5_2 = (event) => {
    setcheckQ_5_2(event);
    setStrokeDashArray_less5(300.36);
    setcheckbtn_quiz_2_5(true);
  };
  const startQuiz_5_3 = (event) => {
    setStrokeDashArray_less5(365.36);
    setcheckQ_5_3(event);
    setcheckbtn_quiz_3_5(true);
  };
  const startQuiz_5_4 = (event) => {
    setcheckQ_5_4(event);
    setcheckbtn_quiz_4_5(true);
    setStrokeDashArray_less5(400.36);
  };
  const startQuiz_5_5 = (event) => {
    setcheckQ_5_5(event);
    setcheckbtn_quiz_5_5(true);
    setStrokeDashArray_less5(458.36);
  };
  const refreshassessment = () => {
    setisOpacity_2(false);
    setcheckQ_5_3("");
    setisfirstquiz_5_3(false);
    setissetQuizAns_5_3_btn(false);
    setworngansQuiz_3(false);
    setrightansQuiz_3(false);
    setq3_next(false);
    setcheckbtn_quiz_3_5(false);
    setStrokeDashArray_less5("");
    setistruefalse_5(false);
    setquizless_5_1(false);
    setquizless_5_2(false);
    setquizless_5_3(false);
    setquizless_5_4(false);
    setquizless_5_5(false);
    setless_5_finresult(false);
    setname_5(false);
    setisfirstquiz_5_1(false);
    setissetQuizAns_5_1_btn("");
    setcheckQ_5_1("");
    setcheckbtn_quiz_1_5(false);
    setq1_next(false);
    setcheckQ_5_2("");
    setisfirstquiz_5_2(false);
    setissetQuizAns_5_2_btn("");
    setworngansQuiz_2(false);
    setrightansQuiz_2(false);
    setq2_next(false);
    setcheckbtn_quiz_2_5(false);
    setisOpacity_1(false);
    setisOpacity_3(false);
    setcheckQ_5_4(false);
    setisfirstquiz_5_4(false);
    setissetQuizAns_5_4_btn(false);
    setworngansQuiz_4(false);
    setrightansQuiz_4(false);
    setq4_next(false);
    setcheckbtn_quiz_4_5(false);
    setisOpacity_4(false);
    setcheckQ_5_5(false);
    setisfirstquiz_5_5(false);
    setissetQuizAns_5_5_btn(false);
    setworngansQuiz_5(false);
    setrightansQuiz_5(false);
    setq5_next(false);
    setcheckbtn_quiz_5_5(false);
    setscore_5([]);
    setscore__per5([]);
    setcorrScore(false);
    setsec_1(true);
    setstokebar([]);
    setworngansQuiz_1(false);
    setrightansQuiz_1(false);
    setisOpacity_11(false);
  };
  //Lesson End 5
  const menubars = () => {
    setcloseBox(!closeBox);
  };
  return (
    <>
      <div
        className={`d-flex main-admin-block align-items-stretch mt-4 ${closeBox ? "" : "close-box"
          }`}
      >
        <div className="flex-shrink-0 side-layer">
          <div className="scroll-height">
            <div className="d-flex flex-column">
              <div className="top-title d-flex flex-column gap-5">
                <h1>Health & Safety Responsibilities</h1>
                <div className="d-flex flex-column gap-1">
                  <div className="progress-bar-full">
                    <div style={{ width: `${barwidth}%` }}></div>
                  </div>
                  <h4 className="pro-number">
                    <span>{leftmenu_bar}%</span> COMPLETE
                  </h4>
                </div>
              </div>

              <div className="d-flex flex-column side-navbar mt-4">
                <Link
                  to="admin-block.html"
                  className="d-flex align-items-center gap-3 list-link anilink active"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Starting Question</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_1 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_1 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less1 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4> Overview of Health & Safety Legislation</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_2 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_2 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less2 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Organisation Responsibilities</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_3 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_3 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less3 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Worker Responsibilities</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_4 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_4 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less4 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
                <Link
                  to="#!"
                  className="d-flex align-items-center gap-3 list-link disable-box rel"
                  data-bs-toggle="tooltip"
                  data-bs-title="Lessons must be completed in order"
                >
                  <div className="flex-shrink-0">
                    <i className="far fa-align-left"></i>
                  </div>
                  <div className="flex-grow-1">
                    <h4>Final Assessment</h4>
                  </div>
                  <div className="flex-shrink-0">
                    <div className="circle-small">
                      {istruefalse_5 && <i className="fas fa-check-circle"></i>}
                      {!istruefalse_5 && (
                        <svg>
                          <circle
                            className="bg"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                          <circle
                            style={{ strokeDasharray: strokeDashArray_less5 }}
                            className="progress two"
                            cx="40"
                            cy="40"
                            r="37"
                          ></circle>
                        </svg>
                      )}
                    </div>
                  </div>
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="flex-grow-1 rightpart">
          {lesson1 && (
            <section id="start1" className="start w-100">
              <div className="d-flex flex-column">
                <Link
                  to={`/start-course/${id}`}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>home</h5>
                </Link>
                <div className="stop">
                  <button
                    type="button"
                    className="tbtn"
                    onClick={() => menubars()}
                  >
                    <i className="fal fa-bars" aria-hidden="true"></i>
                  </button>
                </div>
              </div>
              {startQuestion_1 && (
                <div className="container-xxl px-0">
                  <div className="row">
                    <div className="col-lg-10 offset-md-1 padding">
                      <div className="d-flex flex-column gap-3  py-5 lesson-block intro">
                        <h4>Lesson 1 of 5</h4>
                        <h1>Starting Question</h1>
                        <div className="line"></div>
                      </div>
                      <p>
                        Before we begin, let's assess your current
                        comprehension.
                      </p>
                      <div className="start-quiz d-flex py-4  align-items-center ">
                        <Link to="#">
                          Start Quiz<i className="far fa-angle-right px-2"></i>
                        </Link>
                      </div>
                    </div>
                    <div className="col-lg-10 offset-md-1 padding">
                      <div className="q1 py-5 d-flex flex-column gap-3">
                        <span>
                          Question
                          <br />
                          <strong>01/01</strong>
                        </span>
                        <p>
                          Who is responsible for health and safety within an
                          organisation?
                        </p>
                        <div className="d-flex py-5 flex-column gap-5">
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Trustees"
                                name="fav_language"
                                value="Trustees"
                                checked={checkQ_1 === "Trustees"}
                                onChange={() => startQuiz_1("Trustees")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "Trustees" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Trustees">Trustees</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Shareholders"
                                name="fav_language"
                                value="Shareholders"
                                checked={checkQ_1 === "Shareholders"}
                                onChange={() => startQuiz_1("Shareholders")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "Shareholders" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Shareholders">Shareholders</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Managers"
                                name="fav_language"
                                value="Managers"
                                checked={checkQ_1 === "Managers"}
                                onChange={() => startQuiz_1("Managers")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "Managers" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Managers">Managers</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Workers"
                                name="fav_language"
                                value="Workers"
                                checked={checkQ_1 === "Workers"}
                                onChange={() => startQuiz_1("Workers")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "Workers" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Workers">Workers</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="Directors"
                                name="fav_language"
                                value="Directors"
                                checked={checkQ_1 === "Directors"}
                                onChange={() => startQuiz_1("Directors")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "Directors" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="Directors">Directors</label>
                          </div>
                          <div
                            className={`d-flex gap-3 ${isOpacity ? "opacityy" : ""
                              }`}
                          >

                            <div class="position-relative">
                              <input
                                type="radio"
                                id="All"
                                name="fav_language"
                                value="All"
                                checked={checkQ_1 === "All"}
                                onChange={() => startQuiz_1("All")}
                              />
                              {isfirstquiz &&
                                (issetQuizAns_1_btn === "All" ? (
                                  <div className="check">
                                    <i className="fas fa-check text-success"></i>
                                  </div>
                                ) : (
                                  <div className="check">
                                    <i className="fas fa-times"></i>
                                  </div>
                                ))}
                            </div>
                            <label for="All">All of the above</label>
                          </div>
                        </div>
                        {worngansQuiz_1_1 && (
                          <div className="d-flex justify-content-center">
                            <div className="text-center">
                              <Link to="javascript:void(0)" className="">
                                <i class="fas fa-times"></i>
                              </Link>
                              <p>
                                <strong>Thanks for confirmation</strong>
                              </p>
                              <p>Sorry that's not correct.</p>
                            </div>
                          </div>
                        )}
                        {rightansQuiz_1_1 && (
                          <div className="d-flex justify-content-center">
                            <div className="text-center">
                              <Link to="javascript:void(0)" className="">
                                <i class="fas fa-check"></i>
                              </Link>
                              <p>
                                <strong>Thanks for confirmation</strong>
                              </p>
                              <p>That's correct - well done.</p>
                            </div>
                          </div>
                        )}
                        {subbtn_1 && (
                          <div className="d-flex justify-content-center">
                            <button
                              type="button"
                              onClick={() => Quiz_check("1")}
                            >
                              Next
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {quiz1_result_section && (
                <div className="d-flex justify-content-center  align-items-center py-4">
                  <div
                    className="pie position-relative "
                    data-pie='{ "cut": 30, "percent": 75, "rotation": 144, "colorSlice": "#F50057", "colorCircle": "#f1f1f1", "textPosition": "1em", "fontSize": "1.2rem" }'
                    data-pie-index="1"
                    style={{ width: "500px", height: "500px" }}
                  >
                    <svg
                      role="progressbar"
                      width="500"
                      height="500"
                      viewBox="0 0 100 100"
                      aria-valuemin="0"
                      aria-valuemax="100"
                      aria-valuenow="56"
                    >
                      <circle
                        cx="50%"
                        cy="50%"
                        r="42"
                        shape-rendering="geometricPrecision"
                        fill="none"
                        stroke="#f1f1f1"
                        stroke-width="2"
                        stroke-dashoffset="79.19999999999999"
                        style={{
                          transform: "rotate(144deg)",
                          transformOrigin: "50% 50%",
                        }}
                        stroke-dasharray="264"
                        stroke-linecap=""
                      ></circle>
                      <circle
                        cx="50%"
                        cy="50%"
                        r="42"
                        shape-rendering="geometricPrecision"
                        className="pie-circle-1"
                        fill="none"
                        stroke-width="2"
                        stroke-dashoffset="160.512"
                        stroke-linecap=""
                        style={{
                          transform: "rotate(144deg)",
                          transformOrigin: "50% 50%",
                          strokeDasharray: finalperc,
                        }}
                        stroke={stroke_1}
                        data-angel="56"
                      ></circle>
                    </svg>
                    <div className="pie-text-1">
                      <p>Your score {isresult}</p>
                      {fans && <i className="fas fa-check"></i>}
                      {!fans && <i className="fas fa-times"></i>}
                    </div>
                    <div className="percentage">
                      <p>Passing</p>
                      <p>{isresult}</p>
                    </div>
                    <div className="refresh">
                      <i className="fas fa-redo" onClick={restart_lesson1}></i>
                    </div>
                  </div>
                </div>
              )}
              {quiz1_result_section && (
                <div className="d-flex flex-column">
                  <Link
                    to="#quiz"
                    onClick={() => lessonInstruction("1")}
                    className="backpage text-center d-flex flex-column"
                  >
                    <i className="far fa-angle-down"></i>
                    <h5>Lesson 2</h5>
                  </Link>
                </div>
              )}
            </section>
          )}
          {lesson2 && (
            <section id="legi" className="legi w-100">
              <div className="d-flex flex-column">
                <Link
                  to="javascript:void(0)"
                  onClick={() => lessonInstruction("2")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 1 Starting Question</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 2 of 5</h4>
                      <h1>Overview of Health & Safety Legislation</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-3 py-3 py-md-5">
                      <p>
                        No matter the jurisdiction you're in, the legislative
                        framework remains the same.
                      </p>
                      <p>
                        For an overview of workplace health and safety, as well
                        as to learn about legislation and common workplace
                        hazards, refer to the Health and Safety Awareness
                        e-learning course in BrightSafe. This will help you
                        understand your responsibilities and how they align with
                        the legislation.
                      </p>
                      <p>
                        Keep in mind that each obligation under health and
                        safety legislation is subject to the principle of
                        'reasonably practicable'. This means that everyone with
                        a duty under the relevant Health and Safety Act must do
                        everything reasonably possible to fulfill that duty,
                        considering all known factors. In matters of health and
                        safety, everyone shares the responsibility for
                        maintaining a safe workplace.
                      </p>
                      <p>
                        While we all have a role to fulfill, the level of
                        responsibility varies based on our positions within the
                        organization.
                      </p>
                      <p>
                        Failure to adhere to health and safety legislation can
                        lead to severe consequences for both organizations and
                        individuals, including penalties imposed by relevant
                        health and safety regulators.
                      </p>
                    </div>

                    <div id="conti-btn" className="d-flex py-4">
                      <button type="button" onClick={() => nextsection("2")}>
                        CONTINUE
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson3 && (
            <section id="Organisation" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  to="javascript:void(0)"
                  onClick={() => lessonInstruction("3")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 2 Overview of Health & Safety Legislation</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 3 of 5</h4>
                      <h1>Organisation Responsibilities</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-3 py-3 ">
                      <p>
                        An employer or person conducting a business or
                        undertaking (PCBU) holds various legal responsibilities
                        under health and safety laws.
                      </p>
                      <p>
                        Outlined below are the primary ongoing responsibilities
                        of organizations in the workplace:
                      </p>
                    </div>
                    <div className="d-flex flex-column gap-3 py-3 ">
                      <h6>Managing Hazards & Risk</h6>
                      <p>
                        As covered in other BrightSafe e-learning courses,
                        organizations are required to manage and control all
                        workplace hazards and risks through a risk management
                        process.
                      </p>
                      <p>This involves:</p>
                      <div className="d-flex flex-column gap-3  py-3">
                        <div className="d-flex align-items-center gap-3 gap-md-5">
                          <div className="no1">
                            <p>1</p>
                          </div>
                          <p>
                            Identifying all hazards present in the workplace.
                          </p>
                        </div>
                        <div className="d-flex align-items-center gap-3 gap-md-5">
                          <div className="no1">
                            <p>2</p>
                          </div>
                          <p>
                            Assessing the risks associated with those hazards.
                          </p>
                        </div>
                        <div className="d-flex align-items-center gap-3 gap-md-5">
                          <div className="no1">
                            <p>3</p>
                          </div>
                          <p>
                            Eliminating or minimizing the risks associated with
                            the hazards to the greatest extent possible.
                          </p>
                        </div>
                        <div className="d-flex align-items-center gap-3 gap-md-5">
                          <div className="no1">
                            <p>4</p>
                          </div>
                          <p>
                            Monitoring and reviewing control measures to ensure
                            their effectiveness in reducing or eliminating
                            risks.
                          </p>
                        </div>
                      </div>
                      <p>
                        The individual with management or control of a workplace
                        is legally obligated to ensure, as far as reasonably
                        practicable, that there are no health and safety risks
                        present and that no individual is exposed to risks
                        arising from work activities, including employees and
                        visitors to the workplace. This responsibility extends
                        to individuals entering or exiting the workplace,
                        although it generally excludes residences, unless they
                        are being used for business purposes.
                      </p>
                      <p>
                        A workplace may encompass a vehicle, vessel, aircraft,
                        mobile structure, or any installation on water where a
                        worker may be present during work hours.
                      </p>
                      <p>
                        A workplace can include a vehicle, vessel, aircraft,
                        mobile structure or any installation on water that a
                        worker might be at while at work.
                      </p>
                      <p>
                        To fulfill their "duty of care" obligations, employers
                        or PCBUs must provide:
                      </p>
                      <div className="d-none d-md-block risk position-relative">
                        {/* <div className="round-img py-4">
                          <img
                            className="w-100"
                            src={require("../assets/ohs/images/round-img.jpg")}
                            alt="img"
                          />
                        </div>
                        <div className="safe1">
                          <div className=" position-relative">
                            <div id="safe" className="safe position-relative">
                              <h5>Maintain & Monitor</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Maintain & Monitor</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations must establish processes and
                                  procedures to uphold and oversee their health
                                  and safety management system. This encompasses
                                  conducting suitable reviews of control
                                  measures, work procedures, worker health, and
                                  workplace co
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe2">
                          <div className="position-relative">
                            <div id="safe2" className="safe position-relative">
                              <h5>Safe workplace</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info2">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Safe workplace</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations are required to furnish and
                                  uphold a safe work environment for all
                                  workers.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe3">
                          <div className="position-relative">
                            <div id="safe3" className="safe position-relative">
                              <h5>Safe Systems of Work</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info3">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Safe Systems of Work</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations require a robust framework to
                                  effectively manage health and safety issues.
                                  This framework enables organizations to
                                  comprehend the hazards and risks linked with
                                  their operations. Consultation should be an
                                  integral part of the safe work systems.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe4">
                          <div className=" position-relative">
                            <div id="safe4" className="safe position-relative">
                              <h5>Site Plant & Structures</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info4">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Site Plant & Structures</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations must supply and uphold safe
                                  plant and equipment.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe5">
                          <div className=" position-relative">
                            <div id="safe5" className="safe position-relative">
                              <h5>Information, Training & Supervision</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info5">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Information, Training & Supervision</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations must furnish adequate
                                  information, training, and supervision to
                                  ensure that workers can perform their duties
                                  safely, safeguarding themselves and others
                                  from workplace risks.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe6">
                          <div className=" position-relative">
                            <div id="safe6" className="safe position-relative">
                              <h5>Safe Use, Handling & Storage</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info6">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Safe Use, Handling & Storage</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations are responsible for creating and
                                  supplying procedures to guarantee the safe
                                  utilization, handling, and storage of
                                  hazardous chemicals or substances.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe7">
                          <div className=" position-relative">
                            <div id="safe7" className="safe position-relative">
                              <h5>Adequate Welfare Facilities</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info7">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4>Adequate Welfare Facilities</h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations must supply sufficient
                                  facilities for the welfare of workers at work
                                  and guarantee their access to these
                                  facilities.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="safe8">
                          <div className=" position-relative">
                            <div id="safe8" className="safe position-relative">
                              <h5>Infomation, Training & Supervision</h5>
                              <div className="icon">
                                <i className="far fa-plus"></i>
                              </div>
                            </div>
                            <div className="safe-info8">
                              <div className="safe-please position-relative d-flex flex-column  gap-3">
                                <div className="d-flex justify-content-between ">
                                  <h4> Infomation, Training & Supervision </h4>
                                  <div className="navigation d-flex gap-3 align-items-center ">
                                    <i
                                      id="left"
                                      className="fas fa-chevron-left"
                                    ></i>
                                    <i
                                      id="right"
                                      className="fas fa-chevron-right"
                                    ></i>
                                  </div>
                                </div>
                                <p>
                                  Organizations are required to furnish adequate
                                  information, training, and supervision to
                                  ensure that workers can carry out their tasks
                                  safely, protecting themselves and others from
                                  work-related risks.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div> */}
                      </div>
                      <div className=" d-block d-md-none py-3 d-flex justify-content-center align-items-center bg-light">
                        <div
                          className="card card-1 p-0 shadow"
                          style={{ maxWidth: "100%" }}
                        >
                          <nav>
                            <div
                              className="nav nav-tabs mb-3 nav-fill"
                              id="nav-tab1"
                              role="tablist"
                            >
                              <button
                                className="nav-link active"
                                id="nav-home-tab1"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-home1"
                                type="button"
                                role="tab"
                                aria-controls="nav-home"
                                aria-selected="true"
                              >
                                Maintain & Monitor
                              </button>
                              <button
                                className="nav-link"
                                id="nav-profile-tab2"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-profile2"
                                type="button"
                                role="tab"
                                aria-controls="nav-profile"
                                aria-selected="false"
                              >
                                Safe workplace
                              </button>
                              <button
                                className="nav-link"
                                id="nav-contact-tab3"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-contact3"
                                type="button"
                                role="tab"
                                aria-controls="nav-contact"
                                aria-selected="false"
                              >
                                Safe Systems of Work
                              </button>
                              <button
                                className="nav-link"
                                id="nav-green-tab4"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-green4"
                                type="button"
                                role="tab"
                                aria-controls="nav-green4"
                                aria-selected="false"
                              >
                                Safe Use, Handling & Storage
                              </button>
                              <button
                                className="nav-link"
                                id="nav-adequate-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-adequate"
                                type="button"
                                role="tab"
                                aria-controls="nav-adequate"
                                aria-selected="false"
                              >
                                Adequate Welfare Facilities
                              </button>
                              <button
                                className="nav-link"
                                id="nav-information-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-information"
                                type="button"
                                role="tab"
                                aria-controls="nav-information"
                                aria-selected="false"
                              >
                                Information, Training & Supervision
                              </button>
                              <button
                                className="nav-link"
                                id="nav-training-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-training"
                                type="button"
                                role="tab"
                                aria-controls="nav-training"
                                aria-selected="false"
                              >
                                Infomation, Training & Supervision
                              </button>
                              <button
                                className="nav-link"
                                id="nav-site-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-site"
                                type="button"
                                role="tab"
                                aria-controls="nav-site"
                                aria-selected="false"
                              >
                                Site Plant & Structures
                              </button>
                            </div>
                          </nav>
                          <div
                            className="tab-content p-4 bg-light"
                            id="nav-tabContent"
                          >
                            <div
                              className="tab-pane fade active show"
                              id="nav-home1"
                              role="tabpanel"
                              aria-labelledby="nav-home-tab1"
                            >
                              <p>
                                Organizations must establish processes and
                                procedures to uphold and oversee their health
                                and safety management system. This encompasses
                                conducting suitable reviews of control measures,
                                work procedures, worker health, and workplace co
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-profile2"
                              role="tabpanel"
                              aria-labelledby="nav-profile-tab2"
                            >
                              <p>
                                Organizations are required to furnish and uphold
                                a safe work environment for all workers.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-contact3"
                              role="tabpanel"
                              aria-labelledby="nav-contact-tab3"
                            >
                              <p>
                                Organizations require a robust framework to
                                effectively manage health and safety issues.
                                This framework enables organizations to
                                comprehend the hazards and risks linked with
                                their operations. Consultation should be an
                                integral part of the safe work systems.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-green4"
                              role="tabpanel"
                              aria-labelledby="nav-green-tab4"
                            >
                              <p>
                                Organizations are responsible for creating and
                                supplying procedures to guarantee the safe
                                utilization, handling, and storage of hazardous
                                chemicals or substances.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-adequate"
                              role="tabpanel"
                              aria-labelledby="nav-adequate-tab"
                            >
                              <p>
                                Organizations must supply sufficient facilities
                                for the welfare of workers at work and guarantee
                                their access to these facilities.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-information"
                              role="tabpanel"
                              aria-labelledby="nav-information-tab"
                            >
                              <p>
                                Organizations must furnish adequate information,
                                training, and supervision to ensure that workers
                                can perform their duties safely, safeguarding
                                themselves and others from workplace risks.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-training"
                              role="tabpanel"
                              aria-labelledby="nav-training-tab"
                            >
                              <p>
                                Organizations must furnish adequate information,
                                training, and supervision to ensure that workers
                                can perform their duties safely, safeguarding
                                themselves and others from workplace risks.
                              </p>
                            </div>
                            <div
                              className="tab-pane fade"
                              id="nav-site"
                              role="tabpanel"
                              aria-labelledby="nav-site-tab"
                            >
                              <p>
                                Organizations must supply and uphold safe plant
                                and equipment.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="d-flex flex-column py-2 gap-3">
                        <h6>Consultation</h6>
                        <p>
                          Essential to the overall effectiveness of the health
                          and safety management system is the consultation with
                          workers, i.e., those directly engaged in the work.
                        </p>
                        <p>
                          workers to engage with management to openly address
                          any general concerns regarding health and safety at
                          work.{" "}
                        </p>
                        <p>
                          Every effort should be made to facilitate consultation
                          and communication on vital health and safety matters
                          such as:
                        </p>
                        <ul className="d-flex flex-column gap-3 rep-ul">
                          <li>
                            <p>
                              Risk assessments and subsequent safe work
                              practices.
                            </p>
                          </li>
                          <li>
                            <p>Workplace hazards.</p>
                          </li>
                          <li>
                            <p>Emergency procedures.</p>
                          </li>
                          <li>
                            <p>Existing or new work practices and equipment.</p>
                          </li>
                          <li>
                            <p>Workplace welfare issues.</p>
                          </li>
                        </ul>
                        <p>
                          By doing so, it gives the organisation direct input
                          from those who know the work best, therefore giving a
                          level of ownerships over the decisions resulting in
                          greater acceptance of the decisions and improved
                          morale.
                        </p>
                      </div>
                      <div className="d-flex flex-column  py-2 gap-3">
                        <h6>What are the Responsibilities of an 'Officer'?</h6>
                        <p>
                          An officer within an organization is an individual
                          whose decisions significantly impact the entire
                          organization. This refers to someone who makes or
                          influences significant financial or operational
                          decisions within the business.
                        </p>
                        <p>
                          The definition of an officer for an organization is
                          derived from the definition outlined in the
                          Commonwealth Corporations Act 2001.
                        </p>
                        <p>
                          If you fall under this category, you have additional
                          defined responsibilities under the relevant Health and
                          Safety Act.
                        </p>
                      </div>

                      <p>
                        The duties of an officer involve taking reasonable
                        measures to:
                      </p>
                      <ul className="d-flex flex-column gap-3 rep-ul">
                        <li>
                          <p>
                            Obtain knowledge and stay updated on health and
                            safety issues.
                          </p>
                        </li>
                        <li>
                          <p>
                            Familiarize themselves with the organization,
                            including health and safety hazards and risks.
                          </p>
                        </li>
                        <li>
                          <p>
                            Ensure the organization possesses adequate resources
                            and procedures and utilizes them to mitigate or
                            eliminate health and safety risks.
                          </p>
                        </li>
                        <li>
                          <p>
                            Guarantee the existence of processes to receive and
                            address incident reports, hazards, or other health
                            and safety concerns, as well as procedures to
                            fulfill any additional responsibilities.
                          </p>
                        </li>
                        <li>
                          <p>
                            Confirm that the aforementioned processes and
                            resources are effectively utilized.
                          </p>
                        </li>
                      </ul>
                      <div id="conti-btn" className="d-flex py-4">
                        <button type="button" onClick={() => nextsection("3")}>
                          CONTINUE
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson4 && (
            <section id="Worker" className="legi w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={forth}
                  to="javascript:void(0)"
                  onClick={() => lessonInstructionbk("3")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 3 Organisation Responsibilities</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 4 of 5</h4>
                      <h1>Worker Responsibilities</h1>
                      <div className="line"></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <div className="col-lg-10 offset-md-1 padding">
                    <div className="d-flex flex-column gap-3 py-3 py-md-5">
                      <p>
                        In most jurisdictions, a worker encompasses anyone
                        engaged in work for the organization, including:
                      </p>
                      <ul className="d-flex flex-column gap-3 rep-ul">
                        <li>
                          <p>An employee.</p>
                        </li>
                        <li>
                          <p>
                            A trainee, apprentice, or work experience student.
                          </p>
                        </li>
                        <li>
                          <p>
                            Other individuals at the workplace, which typically
                            includes volunteers, outworkers, contractors or
                            subcontractors, employees of contractors or
                            subcontractors, and employees of labor hire
                            companies.
                          </p>
                        </li>
                      </ul>
                      <p>
                        Workers are obligated to take reasonable care of
                        themselves and refrain from actions that could
                        jeopardize their own health and safety or that of others
                        at the workplace. Additionally, they must adhere to any
                        reasonable health and safety directives from the
                        organization aimed at safeguarding their well-being.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="expect d-flex flex-column gap-3 ">
                  <div className="overlay-box d-flex flex-column ">
                    <div className="container-lg my-auto">
                      <div className="row justify-content-center">
                        <div className="col-lg-10">
                          <div className="d-flex flex-column gap-4 course-textblock">
                            <div className="w-line"></div>
                            <h1>What To Expect As A Worker</h1>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-10 offset-md-1 padding">
                  <div className="d-flex flex-column gap-3 py-3 py-md-5">
                    <p>When a worker joins an organization, they should:</p>
                    <ul className="d-flex flex-column gap-3 rep-ul">
                      <li>
                        <p>
                          Receive instruction and training on the operation of
                          any plant or equipment they will use.
                        </p>
                      </li>
                      <li>
                        <p>
                          Be provided with necessary personal protective
                          equipment (PPE) suitable for their job and trained on
                          its proper use, maintenance, and disposal.
                        </p>
                      </li>
                      <li>
                        <p>
                          Undergo workplace induction, including information on
                          hazards, facilities, and first aid locations.
                        </p>
                      </li>
                      <li>
                        <p>
                          Receive training on emergency evacuation procedures
                          and be familiarized with evacuation points.
                        </p>
                      </li>
                      <li>
                        <p>
                          Be introduced to their immediate supervisor or manager
                          and coworkers.
                        </p>
                      </li>
                      <li>
                        <p>
                          Receive training on safety policies and procedures,
                          including reporting hazards and injuries. If unsure
                          about safety procedures, workers should seek
                          assistance or further training.
                        </p>
                      </li>
                      <li>
                        <p>
                          Understand everyone's safety roles and
                          responsibilities in the workplace.
                        </p>
                      </li>
                      <li>
                        <p>
                          Actively participate in the consultation process and
                          share information about health and safety concerns.
                        </p>
                      </li>
                    </ul>
                    <p>
                      Workers have the right to refuse unsafe work and should
                      not face bullying or harassment for doing so. If asked to
                      perform a task they believe is unsafe, they should raise
                      their concerns with their supervisor or manager.
                    </p>
                  </div>
                  <div className="wroker-img">
                    <img
                      className="w-100"
                      src={require("../assets/ohs/images/worker.png")}
                      alt="img"
                    />
                  </div>
                  <div id="conti-btn" className="d-flex py-4">
                    <button type="button" onClick={() => nextsection("4")}>
                      CONTINUE
                    </button>
                  </div>
                </div>
              </div>
            </section>
          )}
          {lesson5 && (
            <section id="assessment" className="human w-100">
              <div className="d-flex flex-column">
                <Link
                  ref={fifth}
                  to="#Worker"
                  onClick={() => lessonInstructionbk("4")}
                  className="backpage text-center d-flex flex-column"
                >
                  <i className="far fa-angle-up"></i>
                  <h5>Lesson 4 Worker Responsibilities</h5>
                </Link>
              </div>
              <div className="container-xxl px-0">
                <div className="row">
                  <div className="col-lg-10 offset-md-1">
                    <div className="d-flex flex-column gap-3 padding py-5 lesson-block intro">
                      <h4>Lesson 5 of 5</h4>
                      <h1>Final Assessment</h1>
                      <div className="line" style={{ width: "100%" }}></div>
                    </div>
                  </div>
                  <div className="col-12">
                    <div className="border-line">
                      <div className="line-per"></div>
                    </div>
                  </div>
                  <form action="javascript:void(0)">
                    <div className="col-lg-10 offset-md-1 padding py-5">
                      {sec_1 && (
                        <div className="d-flex flex-column gap-5 fullname-block text-center py-5">
                          <h4>
                            Please enter your FULL NAME before you continue:
                          </h4>
                          <div className="d-flex justify-content-center name-form">
                            <div className="d-flex gap-2">
                              <div className="flex-grow-1">
                                <input
                                  type="text"
                                  name=""
                                  id=""
                                  required
                                  onInput={entername_5}
                                  ref={inputRef}
                                  placeholder="Type your name here..."
                                />
                              </div>
                              <div className="flex-shrink-0">
                                <button type="submit" onClick={btn_entername}>
                                  Continue
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {quizless_5_1 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Officers of an organisation do not have any health
                            and safety responsibilities:
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_11 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="q1"
                                  ref={inputRef_q1}
                                  checked={checkQ_5_1 === "True"}
                                  onChange={() => startQuiz_5_1("True")}
                                />
                                {isfirstquiz_5_1 &&
                                  (issetQuizAns_5_1_btn === "True" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="q1">
                                True
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_11 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q1"
                                  id="False"
                                  ref={inputRef_q1}
                                  checked={checkQ_5_1 === "False"}
                                  onChange={() => startQuiz_5_1("False")}
                                />
                                {isfirstquiz_5_1 &&
                                  (issetQuizAns_5_1_btn === "False" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="False">
                                False
                              </label>
                            </div>
                            {worngansQuiz_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_1 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q1_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next("1")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_1_5 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_5("1")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_5_2 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Which of the below are health and safety
                            responsibilities an organisation may be required to
                            perform?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Provide_all"
                                  ref={inputRef_q2}
                                  checked={checkQ_5_2 === "Provide_all"}
                                  onChange={() => startQuiz_5_2("Provide_all")}
                                />
                                {isfirstquiz_5_2 &&
                                  (issetQuizAns_5_2_btn === "Provide_all" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Provide_all"
                              >
                                Provide all necessary PPE
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  ref={inputRef_q2}
                                  id="CD_Provide"
                                  checked={checkQ_5_2 === "CD_Provide"}
                                  onChange={() => startQuiz_5_2("CD_Provide")}
                                />
                                {isfirstquiz_5_2 &&
                                  (issetQuizAns_5_2_btn === "CD_Provide" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="CD_Provide"
                              >
                                CD Provide appropriate health and safety
                                training for workers
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  ref={inputRef_q2}
                                  name="q2"
                                  id="Provide_welfare"
                                  checked={checkQ_5_2 === "Provide_welfare"}
                                  onChange={() =>
                                    startQuiz_5_2("Provide_welfare")
                                  }
                                />
                                {isfirstquiz_5_2 &&
                                  (issetQuizAns_5_2_btn ===
                                    "Provide_welfare" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Provide_welfare"
                              >
                                Provide welfare facilities
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_1 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q2"
                                  id="Complete_accident"
                                  checked={checkQ_5_2 === "Complete_accident"}
                                  onChange={() =>
                                    startQuiz_5_2("Complete_accident")
                                  }
                                />
                                {isfirstquiz_5_2 &&
                                  (issetQuizAns_5_2_btn ===
                                    "Complete_accident" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Complete_accident"
                              >
                                Complete accident and incident investigations
                              </label>
                            </div>
                            {worngansQuiz_2 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_2 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q2_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next("2")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_2_5 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_5("2")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_5_3 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            An organisation must consult with workers on health
                            and safety matters, which of the below are topics
                            that must be discussed?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_2 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="Any_new"
                                  checked={checkQ_5_3 === "Any_new"}
                                  onChange={() => startQuiz_5_3("Any_new")}
                                />
                                {isfirstquiz_5_3 &&
                                  (issetQuizAns_5_3_btn === "Any_new" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Any_new">
                                Any new workplace hazards
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_2 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="New_work"
                                  checked={checkQ_5_3 === "New_work"}
                                  onChange={() => startQuiz_5_3("New_work")}
                                />
                                {isfirstquiz_5_3 &&
                                  (issetQuizAns_5_3_btn === "New_work" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="New_work"
                              >
                                New work practices and new work equipment
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_2 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q3"
                                  id="New_risk"
                                  checked={checkQ_5_3 === "New_risk"}
                                  onChange={() => startQuiz_5_3("New_risk")}
                                />
                                {isfirstquiz_5_3 &&
                                  (issetQuizAns_5_3_btn === "New_risk" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="New_risk"
                              >
                                New risk assessments or Cha nges to existing
                                risk assessments
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_2 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="flexRadioDefault"
                                  id="All_of"
                                  checked={checkQ_5_3 === "All_of"}
                                  onChange={() => startQuiz_5_3("All_of")}
                                />
                                {isfirstquiz_5_3 &&
                                  (issetQuizAns_5_3_btn === "All_of" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="All_of">
                                All of the above
                              </label>
                            </div>
                            {worngansQuiz_3 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_3 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q3_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next("3")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_3_5 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_5("3")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_5_4 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            The relevant health and safety regulators can impose
                            penalties to organisations and individual persons
                            who fail to comply with health and safety
                            legislation:
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_3 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="True"
                                  checked={checkQ_5_4 === "True"}
                                  onChange={() => startQuiz_5_4("True")}
                                />
                                {isfirstquiz_5_4 &&
                                  (issetQuizAns_5_4_btn === "True" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="True">
                                True
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_3 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q4"
                                  id="False"
                                  checked={checkQ_5_4 === "False"}
                                  onChange={() => startQuiz_5_4("False")}
                                />
                                {isfirstquiz_5_4 &&
                                  (issetQuizAns_5_4_btn === "False" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="False">
                                False
                              </label>
                            </div>

                            {worngansQuiz_4 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_4 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q4_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next("4")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_4_5 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_5("4")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {quizless_5_5 && (
                        <div className="d-flex flex-column py-5 fullname-block">
                          <h4>
                            Workers are provided PPE to be worn while performing
                            a specific task. What are the responsibilities of a
                            worker when they are provided PPE?
                          </h4>

                          <div className="d-flex flex-column mt-4 gap-4 name-form">
                            <h5>Please select the correct answer:</h5>
                            <div
                              className={`form-check ${isOpacity_4 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Workers_must"
                                  checked={checkQ_5_5 === "Workers_must"}
                                  onChange={() => startQuiz_5_5("Workers_must")}
                                />
                                {isfirstquiz_5_5 &&
                                  (issetQuizAns_5_5_btn === "Workers_must" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Workers_must"
                              >
                                Workers must wear their PPE whilst performing
                                the task
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_4 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Nothing"
                                  checked={checkQ_5_5 === "Nothing"}
                                  onChange={() => startQuiz_5_5("Nothing")}
                                />
                                {isfirstquiz_5_5 &&
                                  (issetQuizAns_5_5_btn === "Nothing" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label className="form-check-label" for="Nothing">
                                Nothing — they are not responsible for their own
                                health and safety
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_4 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Ensure_they_are"
                                  checked={checkQ_5_5 === "Ensure_they_are"}
                                  onChange={() =>
                                    startQuiz_5_5("Ensure_they_are")
                                  }
                                />
                                {isfirstquiz_5_5 &&
                                  (issetQuizAns_5_5_btn ===
                                    "Ensure_they_are" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Ensure_they_are"
                              >
                                Ensure they are tra ined to safely use the PPE
                              </label>
                            </div>
                            <div
                              className={`form-check ${isOpacity_4 ? " opacityy" : ""
                                }`}
                            >
                              <div class="position-relative">
                                <input
                                  className="form-check-input"
                                  type="radio"
                                  name="q5"
                                  id="Ensure_they"
                                  checked={checkQ_5_5 === "Ensure_they"}
                                  onChange={() => startQuiz_5_5("Ensure_they")}
                                />
                                {isfirstquiz_5_5 &&
                                  (issetQuizAns_5_5_btn === "Ensure_they" ? (
                                    <div className="check">
                                      <i className="fas fa-check text-success"></i>
                                    </div>
                                  ) : (
                                    <div className="check1">
                                      <i className="fas fa-times text-fail"></i>
                                    </div>
                                  ))}
                              </div>
                              <label
                                className="form-check-label"
                                for="Ensure_they"
                              >
                                Ensure they are trained on how to properly
                                maintain and dispose of the PPE
                              </label>
                            </div>

                            {worngansQuiz_5 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-times"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>Sorry that's not correct.</p>
                                </div>
                              </div>
                            )}
                            {rightansQuiz_5 && (
                              <div className="d-flex justify-content-center">
                                <div className="text-center">
                                  <Link to="javascript:void(0)" className="">
                                    <i class="fas fa-check"></i>
                                  </Link>
                                  <p>
                                    <strong>Thanks for confirmation</strong>
                                  </p>
                                  <p>That's correct - well done.</p>
                                </div>
                              </div>
                            )}
                            {q5_next && (
                              <div className="d-flex justify-content-center">
                                <button
                                  type="button"
                                  onClick={() => Quiz_next("5")}
                                >
                                  Next
                                </button>
                              </div>
                            )}
                            {checkbtn_quiz_5_5 && (
                              <div className="d-flex justify-content-end">
                                <button
                                  type="button"
                                  onClick={() => Quiz_check_5("5")}
                                >
                                  Submit
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                      {less_5_finresult && (
                        <div className="d-flex flex-column gap-3 text-center results-block">
                          <h3 className="text-danger">Results</h3>

                          <div className="row gy-3 gy-md-5">
                            <div className="col-lg-6">
                              <h3>
                                <b>Your Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>
                                {score__per5}% ({score_5} points)
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>
                                <b>Passing Score:</b>
                              </h3>
                            </div>
                            <div className="col-lg-6">
                              <h3>80% (40 points)</h3>
                            </div>
                            <div className="col-12">
                              {!corrScore && (
                                <h4 className="text-danger">
                                  <i className="far fa-times text-fail"></i> You
                                  did not pass
                                </h4>
                              )}
                              {corrScore && (
                                <h4 className="text-success">
                                  <i className="far fa-check"></i> You pass
                                </h4>
                              )}
                            </div>
                            {!corrScore ? (
                              <div className="col-lg-">
                                <button
                                  type="button"
                                  onClick={refreshassessment}
                                >
                                  Retry Assessment
                                </button>
                              </div>
                            ) : (
                              <div className="col-lg-">
                                <button type="button" onClick={downloadpdf}>
                                  Download
                                </button>
                              </div>
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </section>
          )}
        </div>
      </div>
    </>
  );
};
